import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  base: css`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-20);
  `,
  toggleWrapper: css`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-20);
    width: 100%;
    .kit-Toggle {
      width: fit-content;
    }
  `,
  daypartGrid: css`
    display: flex;
    flex-direction: column;
    max-width: 100%;
    overflow-x: auto;
  `,
  daypartGridError: css`
    border: 1px solid var(--color-danger);
    border-radius: var(--border-radii-base);
    padding: var(--spacing-8);
  `,
  clickable: css`
    cursor: pointer;
  `,
  readonly: css`
    pointer-events: none;
  `,
  dayWrapper: css`
    padding: 2px;
    width: 100%;
  `,
  day: css`
    padding: 2px;
    width: 100%;
    > div {
      background-color: var(--color-neutral-base, #dadde7);
      height: var(--spacing-24);
      border-radius: 2px;
      width: 100%;
      outline: none;
      display: flex;
      align-items: center;
    }
  `,
  hourHeading: css`
    ${kitText.variant.body}
    width: 100%;
    text-align: center;
    padding-bottom: var(--spacing-4);
    user-select: none;
    outline: none;
    z-index: 0;
  `,
  dayHeading: css`
    ${kitText.variant.body}
    width: var(--spacing-32);
    flex-shrink: 0;
    user-select: none;
    outline: none;
    z-index: 0;
  `,
  stickyLeftHeading: css`
    background-color: var(--color-background-primary);
    position: sticky;
    left: 0;
    height: 100%;
    z-index: 1;
  `,
  selectedDay: css`
    > div {
      background-color: var(--dayparter-selected-color);
    }
  `,
  row: css`
    display: flex;
    justify-content: stretch;
    align-items: center;
    min-width: 720px;
  `,
  footerActions: css`
    display: flex;
    align-items: center;
  `
};
